import apiClient from '../utils/request'

// 查询模板
export function getTemplate() {
  return apiClient.get('/diy/page/24')
}

export function getSetup() {
  return apiClient.get('/setup/list')
}
// 获取文章数据
export function getArticle(deptId) {
  return apiClient.get('/setup/article/articleList?deptId=' + deptId)
}
// 获取文章详情
export function getArticleDetail(id) {
  return apiClient.get(`/setup/article/article/${id}`)
}